import { InvalidRequirements } from './set-password-requirements';
import * as validate from '@chr/online-shared-ui-validators';
import { isPristine } from 'redux-form';

export const syncValidate = (values: any, props: any) => {
  const asyncChecklist = {} as any;
  const invalidRequirements: InvalidRequirements = [];
  const { password, confirmPassword } = values;
  const { firstName, lastName, email, passwordRequirements } = props;

  if (password && passwordRequirements.validCharacters) {
    asyncChecklist.validCharacters = !validate.passwordContainsInvalidCharacters(password);
  }

  if (password && passwordRequirements.minLength) {
    asyncChecklist.minLength = validate.isPasswordLengthValid(password);
  }

  if (password && passwordRequirements.minUpperCase) {
    asyncChecklist.minUpperCase = validate.passwordHasCapitalLetter(password);
  }

  if (password && passwordRequirements.minLowerCase) {
    asyncChecklist.minLowerCase = validate.passwordHasLowerCaseLetter(password);
  }

  if (password && passwordRequirements.minNumber) {
    asyncChecklist.minNumber = validate.passwordHasNumbericValue(password);
  }

  if (password && passwordRequirements.excludeUsername) {
    asyncChecklist.excludeUsername = !validate.passwordContainsPartialUserName(password, email);
  }

  if (password && passwordRequirements.minSymbol) {
    asyncChecklist.minSymbol = validate.passwordHasSpecialCharacter(password);
  }

  if (password && passwordRequirements.firstName) {
    asyncChecklist.firstName = !validate.passwordContainsString(password, firstName);
  }

  if (password && passwordRequirements.lastName) {
    asyncChecklist.lastName = !validate.passwordContainsString(password, lastName);
  }

  Object.keys(asyncChecklist).forEach((requirementKey) => {
    if (!asyncChecklist[requirementKey]) {
      invalidRequirements.push(requirementKey);
    }
  });

  let errors = {};

  if (password && password.length && invalidRequirements.length !== 0) {
    errors = {
      password: {message: 'Password requirements not met', invalidRequirements},
    };
  };

  if(confirmPassword && confirmPassword.length && confirmPassword !== password) {
    errors = {
      confirmPassword: {message: 'Passwords must match'},
    };
  }

  return errors;
};


export const getFormErrorsFromAppState = (state: AppState) => {
  let errors = {};

	if (state.form.setPasswordForm) {
		errors = { ...errors, ...state.form.setPasswordForm.syncErrors };
  }

	return errors;
}

export function isPasswordValid(state: AppState): boolean {
  const setPasswordForm = state.form.setPasswordForm;
  let passwordValid = true;

  if (setPasswordForm && 'syncErrors' in setPasswordForm) {
    passwordValid = (setPasswordForm.syncErrors.password) ? false : true;
  }

  return passwordValid;
}

export function isConfirmPasswordValid(state: AppState): boolean {
  const setPasswordForm = state.form.setPasswordForm;
  let confirmPasswordValid = true;

  if (setPasswordForm && 'syncErrors' in setPasswordForm) {
    confirmPasswordValid = (setPasswordForm.syncErrors.confirmPassword) ? false : true;
  }

  return confirmPasswordValid;
}

export function isFormValid(state: AppState): boolean {
  const setPasswordForm = state.form.setPasswordForm;
  let formValid = false;

  if (isPasswordValid(state) && isConfirmPasswordValid(state)) {
    formValid = true;
  };

  if (setPasswordForm && 'values' in setPasswordForm) {
   formValid = setPasswordForm.values.password === setPasswordForm.values.confirmPassword ? true : false;
  }

  if(isFormPristine(state)) {
    formValid = false;
  }

  return formValid;
}

export function isFormPristine(state: AppState): boolean {
	const formDataIsPristine: boolean = !!state.form && Object.keys(state.form)
		.every((formName) => isPristine(formName)(state));
	return formDataIsPristine;
}
